import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import * as constants from '../../misc/Constants'
import EventRow from './EventRow'
import Placeholder from '../common/Placeholder'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import Pagination from '../common/Pagination'

import styles from './Events.module.scss'
import colors from '../../assets/styles/globals.scss'
import { ReactComponent as GolferIcon } from '../../assets/images/common/icons/golfer-half-icon.svg'
import CustomPlaceholder from '../common/CustomPlaceholder'

const EventsList = ({ events, loader, searchTerm, activePage, setActivePage, quickLog }) => {
  const pageCount = useSelector(state => state.events.pagination?.total_pages)
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  if (loader) {
    return (
      <div className='col-md-6 mx-auto'>
        <Loader message='loading events' />
      </div>
    )
  }

  if (events?.length === 0) {
    if (searchTerm) {
      return (
        <div className='mt-5 w-100'>
          <Placeholder
            title={'No Event Results Found'}
            icon={'fa-search'}
            subtext1={'Nothing matched the search criteria'}
            subtext2={'Please try again'}
          />
        </div>
      )
    } else {
      return (
        <CustomPlaceholder
          icon = {<GolferIcon id='golferIcon' fill={colors.lightNavy} width={'64px'} height={'64px'}/>}
          subtext = {constants.NINE_HOLE_EVENTS_PLACEHOLDER}
          title={'No 9 Hole Events Logged'}
          guideText = {'Learn How to Setup an Event'}
          guideLink = {'https://intercom.help/op-36/en/articles/11145257-how-do-i-set-up-a-9-hole-event-series'}
          buttonText = {'Quick Log an Event'}
          handleAction = {quickLog}
        />
      )
    }
  }

  return (
    <>
      {pageCount > 1 && (
        <Pagination
          pageCount={pageCount}
          activePage={activePage}
          fetchData={(newPage) => setActivePage(newPage)}
        />
      )}
      <div className={pageCount > 1 ? styles.eventsListPaginated : styles.eventsList}>
        {events?.map((event) => (
          <div className='row' key={event.id}>
            <EventRow event={event} timezone={timezone}/>
          </div>
        ))}
      </div>
    </>
  )
}

EventsList.propTypes = {
  quickLog: PropTypes.func,
  events: PropTypes.array,
  loader: PropTypes.bool,
  searchTerm: PropTypes.string,
  activePage: PropTypes.number,
  setActivePage: PropTypes.func,
}

export default EventsList
